import { denyAllConsent, saleOfDataDenied } from '@theme/na-privacy-consent';

document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('#opt-out-button')) return;
    let tries = 0;
    const poll = setInterval(() => {
        if (saleOfDataDenied()) {
            clearInterval(poll);
            denyAllConsent('do-not-sell');
        } else if (++tries > 25) {
            clearInterval(poll);
        }
    }, 200);
});

const link = document.querySelector('.na-privacy-reopen a');
if (link) {
    link.addEventListener('click', (event) => {
        if (window.Pandectes && Pandectes.fn && Pandectes.fn.openPreferences) {
            event.preventDefault();
            Pandectes.fn.openPreferences();
        }
    });
}
